import { leaveGameToLobby } from '../../leaveGame/leaveGameUtil'
import { useOrderInfoStore } from '../../orderInfo/orderInfoStore'
import { ErrorType } from '../model/ErrorType'
import { useErrorPopupStore } from '../store/errorPopupStore'

export function setErrorPopupData(type: ErrorType, options: { enableReload: boolean } = { enableReload: true }) {
  switch (type) {
    // case ErrorType.Disconnected: // TODO: 照道理應該是已經沒人在使用了
    case ErrorType.OverPlayerMaxLose:
    case ErrorType.OverMaxBet:
    case ErrorType.LowerThanMinBet:
    case ErrorType.OverTableMaxBet:
    case ErrorType.LowerThanTableMinBet:
      useErrorPopupStore.setState({
        isShow: true,
        type,
        okCallback: () => {
          removeErrorPopup()
        },
      })
      break
    case ErrorType.UnknownSystemError:
    case ErrorType.SystemError:
    case ErrorType.InsufficientBalance:
    case ErrorType.VoucherError:
    case ErrorType.BetExisted:
    case ErrorType.BetNotFound:
      useOrderInfoStore.getState().clearRecentRefNo()
      useErrorPopupStore.setState({
        isShow: true,
        type,
        okCallback: () => {
          if (options.enableReload) {
            window.location.reload()
          }
          else {
            removeErrorPopup()
          }
        },
      })
      break
    case ErrorType.Reconnecting:
      useErrorPopupStore.setState({
        isShow: true,
        type,
      })
      break
    case ErrorType.SessionExpired:
    case ErrorType.SignalRDisconnected:
      useErrorPopupStore.setState({
        isShow: true,
        type,
        okCallback: () => {
          leaveGameToLobby()
        },
      })
      break
  }
}

export function removeErrorPopup() {
  useErrorPopupStore.setState({
    type: null,
    okCallback: null,
    isShow: false,
  })
}
